import React from 'react'
import Grid from '@material-ui/core/Grid'
import Cryo from './Cryo'
import Bulk from './Bulk'
import Pack from './Pack'
import Gasmatic from './Gasmatic'
import Content from 'components/shared/Content'
import * as utils from 'utils/common'
import { normaliseID } from 'utils/common'
import { TRACKERTYPES } from 'utils/constants'

interface Props {
  device: any
}
const style = {
  borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
}

const ViewMode = ({ device }: Props) => {
  const sensorData = device.info.data
  if (!sensorData) {
    return null
  }

  return (
    <Grid container direction="column">
      {(device.type == 'pack') ? (<Grid item>
        {(device.dporhe != undefined && device.dporhe == 'DP') ? <Content style={style} label="Type" value='DP' /> : <Content style={style} label="Type" value='Pressure Transducer' />}
      </Grid>) :
        (<Grid item>
          {(device.dporhe != undefined && device.dporhe == 'DP') ? <Content style={style} label="Type" value='DP' /> : <Content style={style} label="Type" value={utils.toTitleCase(sensorData.type)} />}
        </Grid>)
      }
      <Grid item>
        <Content style={style} label="Main Battery" value={sensorData.mbat != undefined && `${sensorData.mbat.toFixed(2)} v`} />
      </Grid>
      {(device.type !== 'pack') && (<Grid item>
        <Content style={style} label="MB Date" value={device.mbDate != undefined && utils.dateString(device.mbDate, false)} />
      </Grid>)}
      {(device.type !== 'pack') && (<Grid item>
        <Content style={style} label="MB Type" value={normaliseID(device.mbType)} />
      </Grid>)}
      {!TRACKERTYPES.includes(sensorData.type.toString().toLowerCase()) &&
        (<Grid container direction="column">
          {(device.type !== 'pack') && (<Grid item>
            {(sensorData.type === 'manifold') ? <Content style={style} label="Secondary Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} %`} /> :
              <Content style={style} label="Secondary Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} v`} />}
          </Grid>)}
          {(device.type === 'pack') && (<Grid item>
            <Content style={style} label="PT Battery" value={sensorData.sbat != undefined && `${sensorData.sbat.toFixed(2)} %`} />
          </Grid>)}
          {(device.type !== 'pack') && (<Grid item>
            <Content style={style} label="SB Date" value={device.altDate != undefined && utils.dateString(device.altDate, false)} />
          </Grid>)}
          {(device.type !== 'pack') && (<Grid item>
            <Content style={style} label="SB Type" value={normaliseID(device.sbType)} />
          </Grid>)}
          {sensorData.type === 'cryo' && <Cryo sensor={{ ...sensorData, dporhe: device.dporhe, settings: device.settings }} />}
          {sensorData.type === 'gasmatic' && <Gasmatic sensor={{ ...sensorData, settings: device.settings }} />}
          {sensorData.type === 'bulk' && <Bulk sensor={{ ...sensorData }} />}
          {device.type === 'pack' && <Pack sensor={{ ...sensorData }} />}
        </Grid>)
      }
      <Grid item>
        <Content style={style} label="RSSI" value={device.sensor != undefined && device.sensor.rssi} />
      </Grid>
      <Grid item>
        <Content style={style} label="Received" value={device.sensor != undefined && utils.dateString(device.sensor.datetime, true)} />
      </Grid>
    </Grid>
  )
}
export default ViewMode
